var lib_core = require("lib-core");

var AssetUpdaterStateMachine = require("./assetUpdaterStateMachine.js");

var AssetUpdaterController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        ASSET_UPDATE:            {id: 'upd_1', name: "ASSET_UPDATE"               },
        ASSET_EDIT:              {id: 'upd_2', name: "ASSET_EDIT"                 },
        ASSET_FORK:              {id: 'upd_3', name: "ASSET_FORK"                 }
    });
};

lib_core.inherit(AssetUpdaterController, lib_core.Controller);

module.exports = AssetUpdaterController;

AssetUpdaterController.prototype.createStateMachine = function () {
    return new AssetUpdaterStateMachine(this.root, this.getModel(), this.getCollection(), this.configuration.url);
};

AssetUpdaterController.prototype.getCollection = function () {
    if(this.configuration.collection) {
        return this.root.findByPath(this.configuration.collection);
    }

    return null;
};
